import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on(
    'click',
    '.h-s-button--create-tracked-time-category, .h-s-button--export-tracked-times-csv',
    (e) => {
      $(e.currentTarget).blur();
    }
  );

  $(document).on('change', '.checkbox--create-invoice-w-tracked-time', (e) => {
    const invoiceTimes = [];
    const $createInvoiceBtn = $('.s-button--create-invoice-w-tracked-time');

    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    $('.checkbox--create-invoice-w-tracked-time:checked').each((i, el) => {
      invoiceTimes.push($(el).data('id'));
    });
    if (invoiceTimes.length > 0) {
      $createInvoiceBtn.removeClass('hide');
      if (invoiceTimes.length > 1) {
        $createInvoiceBtn.find('.s-button__text').text(`(${invoiceTimes.length})`);
      } else {
        $createInvoiceBtn.find('.s-button__text').text('');
      }
      const createInvoiceParams = '?ids=' + invoiceTimes.join(',');
      $createInvoiceBtn.attr(
        'href',
        $createInvoiceBtn.attr('href').split('?')[0] + createInvoiceParams
      );
    } else {
      $createInvoiceBtn.addClass('hide');
      $createInvoiceBtn.attr('href', $createInvoiceBtn.attr('href').split('?')[0]);
    }
  });
});
